export function generatePatientId(patients: any[]): string {
  // Get current year (last 2 digits)
  const year = new Date().getFullYear().toString().slice(-2);
  
  // Get all patients registered this year
  const yearPatients = patients.filter(p => p.id.startsWith(year));
  
  // Get the highest sequence number for this year
  const maxSeq = yearPatients.reduce((max, p) => {
    const seq = parseInt(p.id.split('-')[1] || '0');
    return Math.max(max, seq);
  }, 0);
  
  // Generate next sequence number (4 digits)
  const nextSeq = (maxSeq + 1).toString().padStart(4, '0');
  
  // Combine to create ID in format: YY-XXXX
  return `${year}-${nextSeq}`;
}

export function formatPatientId(id: string): string {
  // If ID is a UUID (contains 4 dashes), return a shortened version
  if (id.includes('-') && id.split('-').length === 5) {
    return `ID-${id.substring(0, 8).toUpperCase()}`;
  }
  
  // If ID is already in correct format (YY-XXXX), return as is
  if (id.includes('-') && id.split('-').length === 2) {
    return id;
  }
  
  // If ID is just numbers, format it as YY-XXXX
  const year = new Date().getFullYear().toString().slice(-2);
  return `${year}-${id.padStart(4, '0')}`;
}

export function generateBillNumber(patientId: string, patientBills: any[]): string {
  // Extract year and sequence from patient ID
  const [year, seq] = patientId.split('-');
  
  // Count existing bills for this patient
  const billCount = patientBills.filter(bill => bill.patientId === patientId).length;
  
  // Generate 2-digit bill sequence number
  const billSeq = (billCount + 1).toString().padStart(2, '0');
  
  // Combine to create bill number in format: YY-XXXX-WW
  return `${year}-${seq}-${billSeq}`;
} 